module.exports = __webpack_public_path__ + "static/media/iStock-504311226.7116faad.jpg";